import React from 'react';
import IssueDetail from '../../components/Issues/IssueDetail';

const IssueDetailPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <IssueDetail />
    </div>
  );
};

export default IssueDetailPage;


